import React, { PureComponent } from 'react';
import { Link } from './styled';
export default class ProgressTrackerLink extends PureComponent {
  render() {
    const {
      href,
      onClick,
      label
    } = this.props.item;
    return /*#__PURE__*/React.createElement(Link, {
      href: href,
      onClick: onClick
    }, label);
  }

}